import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactDatetime from "react-datetime";
import "moment/locale/es";
import Select from "react-select";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import { Badge } from "components/Badges/Badge";

var viewActions = require("store/view.actions");
var dateFormat = require("dateformat");
var Const = require("Const");

var Utils = require("Utils");

export const PersonaDataCard = ({
  token,
  persona,
  updatePersona,
  createPersona,
  isRelative,
  isMyProfile,
  isNew,
}) => {
  const [formData, setFormData] = useState({});

  const { isEditing, isSaving } = useSelector((state) => ({
    isEditing: isRelative
      ? state.view.loadingModules.editingRelativeDataCard
      : state.view.loadingModules.editingPersonaDataCard,
    isSaving: isRelative
      ? state.view.loadingModules.savingRelativeDataCard
      : state.view.loadingModules.savingPersonaDataCard,
  }));

  const dispatch = useDispatch();

  const setIsEditing = (value) => {
    dispatch(
      viewActions.isLoadingModule(
        isRelative ? "editingRelativeDataCard" : "editingPersonaDataCard",
        value
      )
    );
  };

  const confirmUpdate = () => {
    if (isNew && !formData.doc_type) {
      viewActions.notification({
        message: "Debes especificar el tipo de documento",
        title: "Atención",
        type: "danger",
      });
    }
    if (isNew && (!formData.doc_nbr || formData.doc_nbr === "")) {
      viewActions.notification({
        message: "Debes especificar el numero de documento",
        title: "Atención",
        type: "danger",
      });
    } else if (isNew && !formData.persona_type) {
      viewActions.notification({
        message: "Debes especificar el tipo de persona",
        title: "Atención",
        type: "danger",
      });
    } else {
      // let save = {};
      if (Object.keys(formData).length > 0) {
        if (isNew) {
          createPersona(token, formData);
        } else {
          updatePersona(token, persona.persona_id, formData, isMyProfile);
        }
        if (!isEditing) {
          setFormData({});
        }
      } else {
        setIsEditing(false);
      }
    }
  };

  const justNumbers = (event) => {
    const re = /^[0-9\b]+$/;

    if (event.target.value === "" || re.test(event.target.value)) {
      handleInputChange(event);
    } else {
      if (formData[event.target.name] !== undefined)
        event.target.value = formData[event.target.name];
      else event.target.value = "";
    }
  };

  const handleInputChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  if (isNew) {
    persona = {};
  }

  return (
    <>
      {persona && (
        <Card>
          <CardHeader>
            <Row>
              <Col className="pr-1" md="6">
                <h5 className="title">Datos Personales</h5>
              </Col>
              <Col className="ml-auto text-right" md="6">
                {isEditing ? (
                  <>
                    <Button
                      color="success"
                      size="sm"
                      disabled={isSaving}
                      onClick={() => confirmUpdate()}
                    >
                      {isSaving ? (
                        <i className="nc-icon nc-refresh-69  fa-spin" />
                      ) : (
                        <>
                          <span className="btn-label">
                            <i
                              className="fa fa-floppy-o"
                              aria-hidden="true"
                            ></i>
                          </span>
                          Grabar
                        </>
                      )}
                    </Button>

                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => setIsEditing(false)}
                    >
                      <span className="btn-label">
                        <i className="fa fa-ban"></i>
                      </span>
                      Cancelar
                    </Button>
                  </>
                ) : (
                  <Button
                    color="default"
                    size="sm"
                    onClick={() => setIsEditing(true)}
                  >
                    <span className="btn-label">
                      <i className="fa fa-pencil"></i>
                    </span>
                    {isNew ? "Nuevo" : "Editar"}
                  </Button>
                )}
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Form>
              <Row>
                <Col className="pr-1" md="4">
                  <FormGroup>
                    <label>Nombres</label>
                    {!isEditing || isMyProfile ? (
                      <p className="form-control-static">{persona.name}</p>
                    ) : (
                      <Input
                        defaultValue={persona.name}
                        placeholder="Nombre"
                        type="text"
                        name="name"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col className="px-1" md="4">
                  <FormGroup>
                    <label>Apellido</label>
                    {!isEditing || isMyProfile ? (
                      <p className="form-control-static">{persona.last_name}</p>
                    ) : (
                      <Input
                        defaultValue={persona.last_name}
                        placeholder="Apellido"
                        type="text"
                        name="last_name"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col className="pl-1" md="4">
                  <FormGroup>
                    <label>Fecha de nacimiento</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {dateFormat(persona.birthdate, "dd-mm-yyyy")}
                      </p>
                    ) : (
                      <ReactDatetime
                        inputProps={{
                          className: "form-control",
                          placeholder: "Ingrese fecha",
                        }}
                        timeFormat={false}
                        closeOnSelect={true}
                        locale="es-ar"
                        onChange={(sel) =>
                          setFormData({ ...formData, birthdate: sel._d })
                        }
                        defaultValue={
                          persona.birthdate ? new Date(persona.birthdate) : ""
                        }
                      />
                    )}
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col className="pr-1" md="4">
                  <FormGroup>
                    <label>Lugar de nacimiento</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.birth_place}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.birth_place}
                        placeholder="localidad"
                        type="text"
                        name="birth_place"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>

                <Col className="px-1" md="4">
                  <FormGroup>
                    <label>Provincia</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.birth_state &&
                          Const.getObjectByValue(
                            Const.STATES,
                            persona.birth_state
                          ).label}
                      </p>
                    ) : (
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="birth_state"
                        defaultValue={Const.getObjectByValue(
                          Const.STATES,
                          persona.birth_state
                        )}
                        onChange={(sel) =>
                          setFormData({ ...formData, birth_state: sel.value })
                        }
                        options={Const.STATES}
                        placeholder="Seleccione Provincia"
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col className="pl-1" md="4">
                  <FormGroup>
                    <label>Nacionalidad</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.nationality &&
                          Const.getObjectByValue(
                            Const.COUNTRIES,
                            persona.nationality
                          ).label}
                      </p>
                    ) : (
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="nationality"
                        defaultValue={Const.getObjectByValue(
                          Const.COUNTRIES,
                          persona.nationality
                        )}
                        onChange={(sel) =>
                          setFormData({ ...formData, nationality: sel.value })
                        }
                        options={Const.COUNTRIES}
                        placeholder="Seleccione País"
                      />
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col className="pr-1" md="4">
                  <FormGroup>
                    <label>Tipo Documento</label>
                    {!isEditing || isMyProfile ? (
                      <p className="form-control-static">
                        {persona.doc_type &&
                          Const.getObjectByValue(
                            Const.USER_DOC_TYPES,
                            persona.doc_type
                          ).label}
                      </p>
                    ) : (
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="doc_type"
                        defaultValue={Const.getObjectByValue(
                          Const.USER_DOC_TYPES,
                          persona.doc_type
                        )}
                        onChange={(sel) =>
                          setFormData({ ...formData, doc_type: sel.value })
                        }
                        options={Const.USER_DOC_TYPES}
                        placeholder="Seleccione tipo de documento"
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col className="px-1" md="4">
                  <FormGroup>
                    <label>Numero</label>
                    {!isEditing || isMyProfile ? (
                      <p className="form-control-static">
                        {persona.doc_nbr}{" "}
                        {persona.doc_nbr && persona.doc_nbr.length > 8 && (
                          <Badge bgcolor="FF0000">Validar DNI</Badge>
                        )}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.doc_nbr}
                        placeholder="numero de documento"
                        type="text"
                        name="doc_nbr"
                        onChange={justNumbers}
                        // onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col className="pl-1" md="4">
                  <FormGroup>
                    <label>Género</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.gender &&
                          Const.getObjectByValue(
                            Const.USER_GENDERS,
                            persona.gender
                          ).label}
                      </p>
                    ) : (
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="gender"
                        defaultValue={Const.getObjectByValue(
                          Const.USER_GENDERS,
                          persona.gender
                        )}
                        onChange={(sel) =>
                          setFormData({ ...formData, gender: sel.value })
                        }
                        options={Const.USER_GENDERS}
                        placeholder="Seleccione género"
                      />
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col className="pr-1" md="4">
                  <FormGroup>
                    <label>Telefono Casa</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {Utils.fmtPhone(persona.phone_home)}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.phone_home}
                        placeholder="ingrese numero"
                        type="text"
                        name="phone_home"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col className="px-1" md="4">
                  <FormGroup>
                    <label>Telefono Movil</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {Utils.fmtPhone(persona.phone_mobile)}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.phone_mobile}
                        placeholder="ingrese numero"
                        type="text"
                        name="phone_mobile"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col className="pl-1" md="4">
                  <FormGroup>
                    <label>Telefono Emergencia</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {Utils.fmtPhone(persona.phone_emergency)}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.phone_emergency}
                        placeholder="ingrese numero"
                        type="text"
                        name="phone_emergency"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col className="pr-1" md="4">
                  <FormGroup>
                    <label>Telefono Laboral</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {Utils.fmtPhone(persona.phone_work)}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.phone_work}
                        placeholder="ingrese numero"
                        type="text"
                        name="phone_work"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col className="px-1" md="4">
                  <FormGroup>
                    <label>Telefono Extra</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {Utils.fmtPhone(persona.phone_extra)}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.phone_extra}
                        placeholder="ingrese numero"
                        type="text"
                        name="phone_extra"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col className="pl-1" md="4">
                  <FormGroup>
                    <label>Correo electrónico</label>
                    {!isEditing ? (
                      <p className="form-control-static">{persona.email}</p>
                    ) : (
                      <Input
                        defaultValue={persona.email}
                        placeholder="email"
                        type="email"
                        name="email"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
              </Row>
              {/* Addresses */}
              <hr />
              <Row>
                <Col className="pr-1" md="4">
                  <FormGroup>
                    <label>Calle</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.addr_street}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.addr_street}
                        placeholder="calle"
                        type="text"
                        name="addr_street"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>

                <Col className="px-1" md="4">
                  <FormGroup>
                    <label>Numero</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.addr_street_nbr}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.addr_street_nbr}
                        placeholder="numero de puerta"
                        type="text"
                        name="addr_street_nbr"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>

                <Col className="pr-1" md="4">
                  <FormGroup>
                    <label>Ciudad</label>
                    {!isEditing ? (
                      <p className="form-control-static">{persona.addr_city}</p>
                    ) : (
                      <Input
                        defaultValue={persona.addr_city}
                        placeholder="ciudad"
                        type="text"
                        name="addr_city"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
              </Row>
              {/* , , , , ,  */}

              <Row>
                <Col className="pr-1" md="4">
                  <FormGroup>
                    <label>Código postal</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.addr_zip_code}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.addr_zip_code}
                        placeholder="codigo postal"
                        type="text"
                        name="addr_zip_code"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>

                <Col className="px-1" md="4">
                  <FormGroup>
                    <label>Provincia</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.addr_state &&
                          Const.getObjectByValue(
                            Const.STATES,
                            persona.addr_state
                          ).label}
                      </p>
                    ) : (
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="addr_state"
                        defaultValue={Const.getObjectByValue(
                          Const.STATES,
                          persona.addr_state
                        )}
                        onChange={(sel) =>
                          setFormData({ ...formData, addr_state: sel.value })
                        }
                        options={Const.STATES}
                        placeholder="Seleccione Provincia"
                      />
                    )}
                  </FormGroup>
                </Col>

                <Col className="pr-1" md="4">
                  <FormGroup>
                    <label>Referencia</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.addr_extra}
                      </p>
                    ) : (
                      <Input
                        defaultValue={persona.addr_extra}
                        placeholder="referencias o indicaciones"
                        type="text"
                        name="addr_extra"
                        onChange={handleInputChange}
                      />
                    )}
                  </FormGroup>
                </Col>
              </Row>

              {/* asdasd */}
              {isNew && (
                <Row>
                  <Col className="pr-1" md="4">
                    <label>Tipo de Persona</label>
                    {!isEditing ? (
                      <p className="form-control-static">
                        {persona.persona_type &&
                          Const.getObjectByValue(
                            Const.PERSONA_TYPES,
                            persona.persona_type
                          ).label}
                      </p>
                    ) : (
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="persona_type"
                        defaultValue={Const.getObjectByValue(
                          Const.PERSONA_TYPES,
                          persona.persona_type
                        )}
                        onChange={(sel) =>
                          setFormData({ ...formData, persona_type: sel.value })
                        }
                        options={Const.PERSONA_TYPES}
                        placeholder="Seleccione tipo de persona"
                      />
                    )}
                  </Col>
                </Row>
              )}
            </Form>
          </CardBody>
        </Card>
      )}
    </>
  );
};
